module.exports = __webpack_public_path__ + "static/media/gif1.45d79cf1.gif";